import { APIClient } from "./apiCore";
import * as url from "./urls";
import { ProfileTypes } from "../data";
const api = new APIClient();

const createUnit = (payload: any) => {
  const response: Promise<any> = api.create(url.CREATE_UNIT, payload);
  return response;
};

const createVat = (payload: any) => {
  const response: Promise<any> = api.create(url.CREATE_VAT, payload);
  return response;
};

const getAllUnits = () => {
  const response: Promise<any> = api.get(url.GET_ALL_UNITS);
  return response;
};

const getAllVats = () => {
  const response: Promise<any> = api.get(url.GET_ALL_VATS);
  return response;
};

const createProduct = (payload: any) => {
  const response: Promise<any> = api.create(url.CREATE_PRODUCT, payload);
  return response;
};

const getAllProducts = () => {
  const response: Promise<any> = api.get(url.GET_ALL_PRODUCTS);
  return response;
};

const getProduct = (params: { productId: string | undefined }) => {
  const response: Promise<any> = api.get(url.GET_PRODUCT, params);
  return response;
};

const updateProduct = (payload: any) => {
  const response: Promise<any> = api.create(url.UPDATE_PRODUCT, payload);
  return response;
};

const deleteProduct = (params: { productId: string | undefined }) => {
  const response: Promise<any> = api.delete(url.DELETE_PRODUCT, params);
  return response;
};

const deleteSelectedProducts = (params: any) => {
  const response: Promise<any> = api.update(url.DELETE_PRODUCTS, params);
  return response;
};

export {
  createUnit,
  createVat,
  getAllUnits,
  getAllVats,
  createProduct,
  getAllProducts,
  getProduct,
  updateProduct,
  deleteProduct,
  deleteSelectedProducts,
};
